import { render, staticRenderFns } from "./NdfAnalytics.vue?vue&type=template&id=1632e0ee&scoped=true"
import script from "./NdfAnalytics.vue?vue&type=script&lang=js"
export * from "./NdfAnalytics.vue?vue&type=script&lang=js"
import style0 from "./NdfAnalytics.vue?vue&type=style&index=0&id=1632e0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1632e0ee",
  null
  
)

export default component.exports